import { createFileRoute } from '@tanstack/react-router';
import { getDefaultStore } from 'jotai';

import { lastOpenProjectAtom } from '#state/atoms/last-open-project-atom.js';

export const Route = createFileRoute('/_authorization-gate/orgs/$orgName/projects/$projectId')({
	staticData: {
		authorize: (ability) => ability.can('view', 'project'),
	},
	beforeLoad: ({ context: { trpc }, params: { projectId } }) => {
		getDefaultStore().set(lastOpenProjectAtom, (prev) => ({
			...prev,
			projectId,
		}));

		return {
			getProjectPreviewOptions: trpc.project.getPreview.queryOptions({ id: projectId }, { refetchOnMount: false }),
		};
	},
});
